export const ELECTRONIC_KINDS = ["us_bank_account", "card"]

export const PAYMENT_METHOD_TYPE_BY_KIND = {
  card: "PaymentMethod::Card",
  us_bank_account: "PaymentMethod::BankAccount",
}

const KIND_BY_PAYMENT_METHOD_TYPE = Object.entries(
  PAYMENT_METHOD_TYPE_BY_KIND
).reduce((map, [kind, type]) => ({ ...map, [type]: kind }), {})

export const kindForPaymentMethod = (
  stripePaymentMethodId,
  paymentMethods = []
) => {
  if (stripePaymentMethodId === "manual") return "manual"

  const selected = paymentMethods.find(
    (paymentMethod) =>
      paymentMethod.stripePaymentMethodId === stripePaymentMethodId
  )

  return (selected && KIND_BY_PAYMENT_METHOD_TYPE[selected.type]) || ""
}

export const paymentSelectionComplete = (state, quote) => {
  const { paymentMethod, paymentMethods, paymentMethodKind, paymentType } =
    state

  if (paymentMethod === "manual" || paymentType === "manual") {
    return (
      Boolean(quote.allowDirectPayment) &&
      paymentType === "manual" &&
      paymentMethod === "manual"
    )
  }

  if (
    paymentMethod === "" ||
    paymentMethod === "add" ||
    paymentType !== "credit"
  ) {
    return false
  }

  const kind =
    paymentMethodKind || kindForPaymentMethod(paymentMethod, paymentMethods)

  return (quote.acceptedPaymentMethods || []).includes(kind)
}
